import { styled } from '@mui/system';
import Paper from "@mui/material/Paper";
import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";
import { styled as deafultStyled } from 'styled-components';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';

export const PaperStyled = styled(Paper)`
    width: 90vw;
    height: 90vh;
    box-shadow: inset;
    outline: none;
    position: relative;
    transition: all 0.5s ease-in;
`;

export const ModalStyled = styled(Modal)`
    display: flex;
    align-items: center;
    justify-content: center;
    outline: none;
`;

export const ImageStyled = deafultStyled.img`
    width: 100%;
    height: 100%;
`;

export const CloseIconBoxStyled = styled(Box)`
    position: absolute;
    right: 0;
    top: 0;
    transform: translateX(50%) translateY(-50%);
    cursor: pointer;
`;

export const HighlightOffIconStyled = styled(HighlightOffIcon)`
    width: 42px;
    height: 42px;
`;